import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { DatePicker } from "@/components/DatePicker";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { dueLabel } from "@/components/documents/docConst";

export const VersionDialog = ({ doc, onClose, onSaved }) => {
  const [f, setF] = useState({ version: "", issue_date: "", due_date: "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (doc) { setF({ version: "", issue_date: "", due_date: "" }); setFile(null); } }, [doc]);
  const save = async () => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      Object.entries(f).forEach(([k, v]) => fd.append(k, v));
      await api.post(`/documents/${doc.id}/versions`, fd);
      toast.success("Nuova versione caricata");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="version-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Rinnova · nuova versione</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">{doc?.title}. La versione precedente resta nello storico.</p>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="sm:col-span-2"><Label className="micro-label">File</Label><Input className="mt-1.5" type="file" onChange={(e) => setFile(e.target.files[0] || null)} data-testid="version-field-file" /></div>
          <div><Label className="micro-label">Versione</Label><Input className="mt-1.5" value={f.version} onChange={(e) => setF({ ...f, version: e.target.value })} placeholder="Es. 2026" data-testid="version-field-version" /></div>
          <div><Label className="micro-label">Data emissione</Label><div className="mt-1.5"><DatePicker value={f.issue_date} onChange={(v) => setF({ ...f, issue_date: v })} clearable testId="version-field-issue" /></div></div>
          <div className="sm:col-span-2"><Label className="micro-label">Nuova {dueLabel(doc?.kind).toLowerCase()} (vuoto = invariata)</Label><div className="mt-1.5"><DatePicker value={f.due_date} onChange={(v) => setF({ ...f, due_date: v })} clearable testId="version-field-due" /></div></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={busy || !file} data-testid="version-save-button">{busy ? "Caricamento…" : "Carica"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
